module.exports = __webpack_public_path__ + "static/img/zncs_logo.5c47fac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/zncs_logo.png
// module id = 8zdj
// module chunks = 11